<template>
  <auth-shell
    welcome="Hoş Geldiniz,"
    title="SMS ile Doğrulama"
    description="Devam etmek için telefonunuza gelen doğrulama kodunu girin."
  >
    <div class="vy-card">
      <div v-if="errorMessage" class="vy-error" role="alert">
        <span class="material-symbols-outlined">error</span>
        <span v-text="errorMessage"></span>
      </div>

      <div class="vy-notice">
        <span class="vy-notice-icon"><span class="material-symbols-outlined">smartphone</span></span>
        <p v-if="loginData.Mobile">
          <b>{{ loginData.Mobile }}</b> numaralı telefonunuza doğrulama kodu SMS olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır.
        </p>
        <p v-else>
          Telefonunuza doğrulama kodu SMS olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır.
        </p>
      </div>

      <form @submit.prevent="login()">
        <fieldset :disabled="loading" class="vy-fieldset">
          <label class="vy-label" for="OTP">Doğrulama kodunu giriniz</label>
          <div class="vy-field mfa-code-field">
            <span class="material-symbols-outlined vy-field-icon">lock</span>
            <input
              id="OTP"
              v-model="loginData.OTP"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              placeholder="Doğrulama kodu"
              required
            />
          </div>

          <div class="vy-actions">
            <button type="submit" class="btn vy-btn vy-btn-orange">Devam Et</button>
          </div>
        </fieldset>
      </form>
    </div>
  </auth-shell>
</template>

<script>
import axios from "axios";
import AuthShell from "../components/Voya/AuthShell.vue";
export default {
  name: "LoginWithMFA",
  components: {
    AuthShell
  },
  props: {
    loginData: Object
  },
  created() {
    if (this.loginData == null) this.$router.push("/");
  },
  data: () => ({
    loading: false,
    errorMessage: null
  }),
  methods: {
    imgLogoPath() {
      try {
        return window.settings.customization.imgLogo == null ? require("../assets/logo.png") : "../img/" + window.settings.customization.imgLogo;
      } catch (e) {
        return require("../assets/logo.png");
      }
    },
    async loginWithMFA(accountCode, email, sessionId, OTP) {
      const { data } = await axios.post("/token/postMFA", {
        AccountCode: accountCode,
        Email: email,
        SessionId: sessionId,
        OTP: OTP,
        Source: "Mobile"
      });
      return data;
    },
    login() {
      console.log("Oluşturuldu:", this);
      this.loading = true;
      this.loginWithMFA(
        this.loginData.AccountCode,
        this.loginData.Email,
        this.loginData.SessionId,
        this.loginData.OTP
      )
        .then(x => {
          this.errorMessage = null;
          console.log("Gelen sonuç:", x);
          if (x.Success) {
            window.localStorage.setItem("user", JSON.stringify(x.Data));
            axios.defaults.headers.common["token"] = x.Data.Key;
            this.$root.$data.login = x.Data;
            this.registerDeviceToken();
            this.saveBaseUrl();
            this.$store.commit("setUser", x.Data.User);
            if(this.$route.query.redirect)
              this.$router.push(this.$route.query.redirect);
            else
              this.$router.push("/index");
            console.log(
              "Token geldi: ",
              axios.defaults.headers.common["token"]
            );
          } else {
            this.errorMessage = x.ErrorMessages;
            this.loginData.OTP = "";
            this.loading = false;
          }
          console.log("Token geldi: ", axios.defaults.headers.common["token"]);
        })
        .catch(e => {
          console.log("Error:", e);
          this.loginData.OTP = "";
          if (e.response === undefined) {
            this.errorMessage =
              "Erişim sağlanamadı. Lütfen internet bağlantınızı kontrol edin.";
          } else if (e.response.status == 400) {
            this.errorMessage =
              window.getModelStateString(e.response.data.ModelState) ||
              e.response.data.Message;
          } else {
            this.errorMessage =
              "Beklenmeyen bir hata oluştu. Lütfen bir süre sonra tekrar deneyin";
          }
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.mfa-code-field input {
  letter-spacing: 2px;
}

.mfa-code-field input::placeholder {
  letter-spacing: 0;
}
</style>
